function ok() { return { ok: true }; }
function fail(field, message) {
    return { ok: false, errors: [{ field, message }] };
}
const concatWithField = {
    id: 'concat_with_field',
    family: 'cross-field',
    label: 'Concat with another field',
    description: 'Combine this value with another field\'s value, joined by a separator.',
    defaultConfig: { fieldName: '', separator: ' ', position: 'after' },
    evaluate: (input, config, ctx) => {
        const c = config;
        const self = input === null || input === undefined ? '' : String(input);
        const otherRaw = ctx.allFieldValues[c.fieldName];
        const other = otherRaw === null || otherRaw === undefined ? '' : String(otherRaw);
        return c.position === 'before' ? `${other}${c.separator}${self}` : `${self}${c.separator}${other}`;
    },
    validate: (config) => {
        const c = config;
        if (!c.fieldName)
            return fail('fieldName', 'fieldName is required');
        if (typeof c.separator !== 'string')
            return fail('separator', 'separator is required');
        if (!['before', 'after'].includes(c.position ?? ''))
            return fail('position', 'position must be before or after');
        return ok();
    },
    formSchema: [
        { key: 'fieldName', label: 'Other field', type: 'text', required: true, helpText: 'Field name to concatenate with.' },
        { key: 'separator', label: 'Separator', type: 'text', required: true },
        { key: 'position', label: 'Position', type: 'select', required: true, options: [
                { value: 'after', label: 'After this value' },
                { value: 'before', label: 'Before this value' },
            ] },
    ],
    sampleSeeds: ['John', 'Acme'],
};
export const crossFieldOps = [concatWithField];
//# sourceMappingURL=cross-field-ops.js.map